import { Button, Checkbox, Input } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ShebaFintechLayout from "../../../layouts/ShebaFintechLayout";

export default function ShebaFintechMerchant() {
  const [agree, setAgree] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <ShebaFintechLayout>
        <div className="self-stretch text-center justify-center text-white text-sm font-medium font-['Inter'] leading-normal">
          Your ShebaPay merchant account number
        </div>

        <div className="mt-3">
          <Input placeholder="017XXXXXX03" />
        </div>

        <div className="mt-4">
          <Checkbox
            className="!select-none !font-medium"
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
          >
            <div className="justify-start">
              <span className="text-white text-base font-medium font-['Inter'] leading-7">
                I agree to the{" "}
              </span>
              <span className="text-white text-base font-medium font-['Inter'] underline leading-7">
                terms and conditions
              </span>
            </div>
          </Checkbox>
        </div>

        <div className="flex justify-center items-center gap-3 mt-4">
          <Button
            onClick={() => navigate("/admin/sheba-pay-wallet")}
            className="w-[50%] self-stretch px-5 py-2.5 bg-cyan-600 text-white hover:!text-white uppercase rounded-md outline outline-1 outline-offset-[-1px] outline-cyan-400 inline-flex justify-center items-center gap-2.5"
          >
            Close
          </Button>
          <Button
            onClick={() =>
              navigate("/admin/sheba-pay-wallet/sheba-fintech/verification")
            }
            className="w-[50%] self-stretch px-5 py-2.5 bg-cyan-600 text-white hover:!text-white uppercase rounded-md outline outline-1 outline-offset-[-1px] outline-cyan-400 inline-flex justify-center items-center gap-2.5"
          >
            Proceed
          </Button>
        </div>
      </ShebaFintechLayout>
    </>
  );
}
